import React from 'react';
import { Box } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import { PoppIcon } from 'common/icons/PoppIcon';
import { RedirectCard } from 'common/ui/RedirectCard';

const container: SxProps = {
  paddingBottom: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 2
};

export const ConnectionSuccessfulPage: React.FC = () => {
  return (
    <Box sx={container}>
      <PoppIcon variant="dark" />
      <RedirectCard
        redirectType="success"
        title="Connection successful"
        message="You will receive invitations when candidates book meetings or interviews via Popp."
      />
    </Box>
  );
};
